/* tslint:disable */
import {
  Product,
  ProductUom
} from '../index';

declare var Object: any;
export interface PurchaseRequisitionLineInterface {
  "id"?: number;
  "product_qty": number;
  "price_unit": number;
  "process_qty"?: number;
  "request_id"?: number;
  "product_id"?: number;
  "product_uom_id"?: number;
  product?: Product;
  uom?: ProductUom;
}

export class PurchaseRequisitionLine implements PurchaseRequisitionLineInterface {
  "id": number;
  "product_qty": number;
  "price_unit": number;
  "process_qty": number;
  "request_id": number;
  "product_id": number;
  "product_uom_id": number;
  product: Product;
  uom: ProductUom;
  constructor(data?: PurchaseRequisitionLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PurchaseRequisitionLine`.
   */
  public static getModelName() {
    return "PurchaseRequisitionLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PurchaseRequisitionLine for dynamic purposes.
  **/
  public static factory(data: PurchaseRequisitionLineInterface): PurchaseRequisitionLine{
    return new PurchaseRequisitionLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PurchaseRequisitionLine',
      plural: 'PurchaseRequisitionLines',
      path: 'PurchaseRequisitionLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "product_qty": {
          name: 'product_qty',
          type: 'number'
        },
        "price_unit": {
          name: 'price_unit',
          type: 'number'
        },
        "process_qty": {
          name: 'process_qty',
          type: 'number'
        },
        "request_id": {
          name: 'request_id',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "product_uom_id": {
          name: 'product_uom_id',
          type: 'number'
        },
      },
      relations: {
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        uom: {
          name: 'uom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/PurchaseRequisitionLine.ts